import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components"
import { CartContext } from "../../Context/Context";
import Wrapper from "../Home/Wrappe";

 const Homebutton = styled.button`
  margin: 10px;
  padding: 15px;
  margin-top: 20px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: bold;
  background-color: transparent;
  outline: none;

  border:  ${(props) => props.bor === "light" ? "1px solid black": " 1px solid white"};
  
    color:  ${(props) => props.bor === "light" ? "#294064": "white"};
  &:hover{
    color: ${(props) => props.bor === "light" ? "white": "#294064"};
  background-color:${(props) => props.bor === "light" ? "#294064": "white"};
  border:  2px solid #F0064C;
  }

  
`;



function Projects() {

  const {Theme}  = useContext(CartContext)
  console.log("this"+Theme)  
  

  const Projectdiv = styled.div`

margin-top: 50px;
    

    .techimage > img{
        width: 50px;
        height: 50px;
        border-radius: 50px;
        margin: 10px;
    }
    .mainproject{
        display: flex;
        text-align: start;
        margin-top: 30px;
    }
    @media (max-width:800px){
      .mainproject{
        display: flex;
        flex-direction: column;
        text-align: start;
        width: 100%;
 
        margin-top: 10px;
      }
      .projectimage{
        width: 100%;

      
      }
      .projectimage > img{
       max-width:100%;
        max-height: 350px;
        border:  2px solid lightgray;
        margin-top: 30px;
        margin-right: 50px;
    }
    .projectdetails{
      margin-top: 20px;
    }
        
    }
    
    .projectimage > img{
        width: 550px;
        height: 350px;
        border:  2px solid lightgray;
        margin-top: 30px;
        margin-right: 50px;
    }
    .projectdetails > h2{
        margin-top: 30px;
            font-size: 40px;
    }
    .projectdetails > h2:hover{
            font-size: 40px;
            color: #F0064C;
    }
    .projectdetails > h3{
            font-size: 25px;
    }
   li{
       font-size: 20px;
   }
`;
const onHandleClick = (l)=>{
  window.open(l, "_blank")

}

  return ( <Wrapper>
    <div id="project">

    <Container fluid className="project-section" >
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <h3 >
          Here are a few projects I've worked on recently.
        </h3>
       
        <Projectdiv id="project">
     
            
            <div className="mainproject" data-aos="fade-right">
                <div className="projectimage" >
                    <img src="https://raw.githubusercontent.com/codewithritik/tvapple-Clone/main/Screenshots/ezgif.com-gif-maker.gif" alt="home page gif" srcset="" /> </div>
                <div className="projectdetails">
                <h2>AppleTv+ Clone</h2>
                                    <p>A web application to watch all tv shows and movies online.</p>
                    
                    <h3>Areas of Responsibility</h3>
                    <ul>
                        <li>I build a Sign-up and Sign-in Page.</li>
                        <li>I Created OTP Page.</li>
                        <li>I designed the header of the Website.</li>
                    </ul>
                    <h3>Tech Stack</h3>
                    <div className="techimage">
                
                  <img src="https://cdn3.iconfinder.com/data/icons/popular-services-brands/512/html5-512.png" alt="" srcset="" />
                  <img src="https://cdn1.iconfinder.com/data/icons/social-media-logos-7/64/css-3-512.png" alt="" srcset="" />
                  <img src="https://cdn.iconscout.com/icon/free/png-256/javascript-2752148-2284965.png" alt="" srcset="" />
              
                
                    </div>
                    <Homebutton bor={Theme}  onClick={()=>{
                        onHandleClick(`https://github.com/codewithritik/tvapple-Clone`)
                    }}>
                    <i class="bi bi-github"></i>  View Code
                    </Homebutton>
                    <Homebutton  bor={Theme}  onClick={()=>{
                        onHandleClick(`https://apple-tvclone.netlify.app/`)
                    }}>
                    <i class="bi bi-box-arrow-up-right"></i> View Demo
                    </Homebutton>
                    <Homebutton   bor={Theme}  onClick={()=>{
                        onHandleClick(`https://medium.com/@ritikadvice/clone-of-apple-tv-816b8f5ea19`)
                    }}>
                   <i class="bi bi-medium"></i> Read Blog
                    </Homebutton>
                    
                </div>
            </div>            


            {/* SECOND PROJECT */}

             <div className="mainproject" data-aos="fade-left">
                <div className="projectimage" >
                    <img src="https://raw.githubusercontent.com/codewithritik/Healthkart-clone/main/image/ezgif.com-gif-maker.gif" alt="home page gif" srcset="" /> </div>
                <div className="projectdetails">
                    <h2>Healthkart Clone</h2>
                    <p>An e-commerce website to buy the health-
                    related product.</p>
                    <h3>Areas of Responsibility</h3>
                    <ul>
                        <li>I build a Flash Sale and Trending Page.</li>
                        <li>I add google authentication functionality on
                        the login and signup page.</li>
                <li>I made Product API throw MongoDB and fetch in frontend.</li>
                    </ul>
                    <h3>Tech Stack</h3>
                    <div className="techimage">
                
                  <img src="https://cdn3.iconfinder.com/data/icons/popular-services-brands/512/html5-512.png" alt="" srcset="" />
                  <img src="https://cdn1.iconfinder.com/data/icons/social-media-logos-7/64/css-3-512.png" alt="" srcset="" />
                  <img src="https://cdn.iconscout.com/icon/free/png-256/javascript-2752148-2284965.png" alt="" srcset="" />
                  <img src="https://e7.pngegg.com/pngimages/925/447/png-clipart-express-js-node-js-javascript-mongodb-node-js-text-trademark.png" alt="" srcset="" />
                  <img src="https://banner2.cleanpng.com/20180403/hyq/kisspng-mongodb-node-js-npm-open-source-model-angularjs-leaf-5ac44d9ed28fc7.7809651415228143668625.jpg" alt="" srcset="" />
                  <img src="https://e7.pngegg.com/pngimages/788/406/png-clipart-node-js-scalable-graphics-javascript-react-scratch-logo-angle-text.png" alt="" srcset="" />
          
                    </div>
                    <Homebutton  bor={Theme}  onClick={()=>{
                        onHandleClick(`https://github.com/codewithritik/Healthkart-clone`)
                    }}>
                    <i class="bi bi-github"></i>  View Code
                    </Homebutton>
                    <Homebutton  bor={Theme} onClick={()=>{
                        onHandleClick(`https://healthkart-clone01.netlify.app/`)
                    }}>
                    <i class="bi bi-box-arrow-up-right"></i> View Demo
                    </Homebutton>
                    <Homebutton bor={Theme}  onClick={()=>{
                        onHandleClick(`https://medium.com/@ritikadvice/healthkart-clone-e30bfe8a6e2e`)
                    }}>
                   <i class="bi bi-medium"></i> Read Blog
                    </Homebutton>
                </div>
            </div>



            {/* {Third project} */}
               
<div className="mainproject" data-aos="fade-right">
                <div className="projectimage" >
                    <img src="https://github.com/codewithritik/Healthkart-clone/blob/main/image/video1950801823_Trim.gif?raw=true" alt="home page gif" srcset="" /> </div>
                <div className="projectdetails">
                    <h2>Mamaearth Clone</h2>
          <p>Mamaearth.in is an Indian company Website for Buy Beauty and Skin realted Products.</p>
                    <h3>Areas of Responsibility</h3>
                    <ul>
                        <li> build Home page with Carousel Features Added using Chakra UI Library.</li>
                        <li>I Create Login Sing-Up and OTP Page as a Modal Dialog using Chakra UI.</li>
                    <li>Add to Card page as Drawer Component and Checkout Page.</li>
                </ul>
               
                    <h3>Tech Stack</h3>
                    <div className="techimage">
                
                  <img src="https://cdn.svgporn.com/logos/react.svg" alt="" srcset="" />
                  <img src="https://cdn1.iconfinder.com/data/icons/social-media-logos-7/64/css-3-512.png" alt=""  />
                  <img src="https://cdn.iconscout.com/icon/free/png-256/javascript-2752148-2284965.png" alt=""  />
                   <img src="https://portfolio1-nishthaarya.vercel.app/static/media/redux.168e37f0.png" alt=""  />
                  <img src="https://e7.pngegg.com/pngimages/925/447/png-clipart-express-js-node-js-javascript-mongodb-node-js-text-trademark.png" alt=""  />
                  <img src="https://e7.pngegg.com/pngimages/788/406/png-clipart-node-js-scalable-graphics-javascript-react-scratch-logo-angle-text.png" alt="" />
                
                    </div>
                    <Homebutton bor={Theme}  onClick={()=>{
                        onHandleClick(`https://github.com/codewithritik/MamaEarth-Clone`)
                    }}>
                    <i class="bi bi-github"></i>  View Code
                    </Homebutton>
                    <Homebutton  bor={Theme}  onClick={()=>{
                        onHandleClick(`https://mamaearthclone.netlify.app/`)
                    }}>
                    <i class="bi bi-box-arrow-up-right"></i> View Demo
                    </Homebutton>
                    {/* <Homebutton   bor={Theme}  onClick={()=>{
                        onHandleClick(`https://medium.com/@ritikadvice/clone-of-apple-tv-816b8f5ea19`)
                    }}>
                   <i class="bi bi-medium"></i> Read Blog
                    </Homebutton> */}
                    
                </div>
            </div>    
        </Projectdiv>
        
      </Container>
    </Container>
    </div>
  </Wrapper>

  );
}

export default Projects;
